/**
 * HeaderUtilities — 목록 화면 헤더 우측의 날짜 칩.
 *
 * 구 픽커 헤더의 우측 유틸리티 묶음을 공용 컴포넌트로 복원 (2026-08-12
 * 사용자 지시). Workspaces·Simulations 가 같은 컴포넌트를 써서 동형을 보장한다.
 * 알림·메일 아이콘은 기능이 배선될 때까지 두지 않는다 — '(준비 중)' 버튼이
 * 베타 사용자에게 노출됐다(게시판 #23, 2026-09-07 사용자 결정: 숨김).
 */

import React from 'react';
import { Box } from '@mui/material';
import { formatMonthDay } from '@/shared/dateTime';

const HeaderUtilities: React.FC = () => {
  const currentDate = formatMonthDay();
  return (
    <>
      {/* 날짜는 표시 전용 — 버튼으로 두면 동작 없는 탭 정지가 된다 (리뷰 반영) */}
      <Box
        sx={{
          px: 1.75,
          py: 0.75,
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 1,
          typography: 'button',
          textTransform: 'none',
          color: 'text.primary',
          lineHeight: 1.5,
        }}
      >
        {currentDate}
      </Box>
    </>
  );
};

export default HeaderUtilities;
